var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepStyleStomachGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.311,
    height: 120.92,
    viewBox: "0 0 45.311 120.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4636",
    "data-name": "Group 4636",
    transform: "translate(-1671.102 -468.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6992",
    "data-name": "Path 6992",
    d: "M147.654,399.352c-.223.285,1.816.811,1.816.811s-3.786-.056-4.464.026.862,1.441.767,1.367c-.3.38.726,1.029.9,1.008-.162.793.854.669,1.011,1.252,1.318.439,3.631-.274,4.6-.617l0,.015a19.187,19.187,0,0,1,4.617-.926,35.636,35.636,0,0,0-.166-3.861l-5.089,1.3c-.441-.805-3.774-.659-4-.374",
    transform: "translate(1541.763 112.967)",
    fill: "#ef8062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6993",
    "data-name": "Path 6993",
    d: "M130.436,23.451l-1.989-.277a131.1,131.1,0,0,0-27.058-.944,2.233,2.233,0,0,1-2.348-2.637l.382-2.044A47.935,47.935,0,0,0,99.831,2.52a2.233,2.233,0,0,1,2.542-2.5l.353.053a131.1,131.1,0,0,0,26.99,1.2l1.64-.1a2.233,2.233,0,0,1,2.322,2.66l-.258,1.307a47.933,47.933,0,0,0-.569,14.916l.109.915a2.233,2.233,0,0,1-2.525,2.475",
    transform: "translate(1582.691 468.77)",
    fill: "#d7e9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6994",
    "data-name": "Path 6994",
    d: "M223.008,95.83s2.312,4.7,6.646,2.924,3.052-11.564.2-12.344-8.744,2.411-6.849,9.421",
    transform: "translate(1472.282 391.704)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6995",
    "data-name": "Path 6995",
    d: "M231.117,176.423a10.808,10.808,0,0,1-.345,2.539,3.092,3.092,0,0,0,2.745,3.965,3.693,3.693,0,0,0,2.351-.646c2.061-1.453,1.164-5.227,1.164-5.227Z",
    transform: "translate(1465.127 311.218)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6996",
    "data-name": "Path 6996",
    d: "M182.468,454.421l-.54,6.845,16.571-.18-.72-8.466Z",
    transform: "translate(1508.638 64.571)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6997",
    "data-name": "Path 6997",
    d: "M252.482,933.107l-4.6-3s.339,11.9-.351,12.356a6.385,6.385,0,0,0-1.765,1.687,1.262,1.262,0,0,0,.136,1.691L253,951.425c.4.3,1.034-.157.974-.7-.089-.794-.831-1.695-1.542-3.492a12.259,12.259,0,0,0-1.065-2.118c-.319-.5,1.121-12.009,1.121-12.009",
    transform: "translate(1451.86 -361.833)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6998",
    "data-name": "Path 6998",
    d: "M158.36,930.887l4.6-2.995s-.35,11.9.34,12.356a6.383,6.383,0,0,1,1.763,1.688,1.262,1.262,0,0,1-.137,1.691l-7.1,5.575c-.4.3-1.034-.158-.973-.7.089-.794.832-1.694,1.546-3.49a12.266,12.266,0,0,1,1.067-2.117c.319-.5-1.11-12.01-1.11-12.01",
    transform: "translate(1531.029 -359.853)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6999",
    "data-name": "Path 6999",
    d: "M97.553,168.443c-.21-4.523-.8-13.248-3.484-15.662-2.306-2.077-10.021-4.639-12.2-4.409l-5.9.717.609-2.84-1.826-4.463s-12.172,1.623-13.186,5.274,7.3,12.172,9.332,13.389,3.347,6.714,3.347,6.714-.812,9.8,0,11.47,16.635,3.007,17.446.78a26.565,26.565,0,0,0,.544-6.062c1.118-.442,2.178-.89,3.059-1.275a3.774,3.774,0,0,0,2.26-3.633",
    transform: "translate(1616.2 342.15)",
    fill: "#b1d34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7000",
    "data-name": "Path 7000",
    d: "M349.158,355.361c-1.014-.71-1.623-10.346-1.724-8.622-.1,2.029.139,9.454.139,9.454.6-.239,1.188-.478,1.738-.709a1.925,1.925,0,0,0-.152-.123",
    transform: "translate(1360.862 159.307)",
    fill: "#d7e9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7001",
    "data-name": "Path 7001",
    d: "M146.618,512.269c-.913,2.177-3.347,17.724-3.5,22.543s.3,25.031,2.891,26.274,5.934-.933,5.934-.933l1.978-26.275s.609,25.031,1.521,25.964,4.564,3.887,6.238.622,3.5-22.7,3.8-27.674-.609-20.522-1.369-21.144-16.584-1.555-17.5.622",
    transform: "translate(1543.319 12.521)",
    fill: "#b1d34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    d: "M29.077,55.363a9.56,9.56,0,0,1,2.491-2.908c1.771-1.4,3.748-4.13.8-8.314-4.565-6.479-10.558-2.476-15.434.3s-8.982-3.366-12.516-.876S-3.437,56.81,4.4,58.556s8.383-.044,11.793.418,7.49.427,10.346-1.116a6.154,6.154,0,0,0,2.533-2.5",
    transform: "translate(1671.102 432.467)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4402",
    "data-name": "Rectangle 4402",
    width: 45.311,
    height: 120.92,
    transform: "translate(1671.102 468.766)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepStyleStomachGreen);
export default __webpack_public_path__ + "static/media/sleepStyleStomachGreen.ef6c70f297efede6c1ce2448164e962e.svg";
export { ForwardRef as ReactComponent };